import React from 'react';
import { getOperarioNombre, formatDateTime } from '../utils/helpers';

const OperarioHistory = ({ operarios, operaciones }) => {
  return (
    <div className="bg-white p-6 rounded-2xl shadow-lg transition-colors duration-300">
      <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center">Historial de Operarios</h2>
      {operarios.length === 0 ? (
        <p className="text-gray-500 text-center py-4 text-base">No hay operarios registrados.</p>
      ) : (
        <div className="space-y-6">
          {operarios.map(operario => {
            const operarioOperations = operaciones.filter(op => op.operarioId === operario.id);
            const initiatedOps = operarioOperations.filter(op => op.estado === 'iniciada' || op.estado === 'pausada');
            const completedOps = operarioOperations.filter(op => op.estado === 'terminada');

            return (
              <div key={operario.id} className="bg-gray-50 p-5 rounded-xl border border-gray-200 transition-colors duration-300">
                <h3 className="text-xl font-bold text-gray-900 mb-3">{operario.nombre}</h3>

                {initiatedOps.length > 0 && (
                  <div className="mb-3">
                    <h4 className="text-lg font-semibold text-indigo-700 mb-2">Operaciones en Curso/Pausadas:</h4>
                    <ul className="list-disc list-inside space-y-1 text-gray-700">
                      {initiatedOps.map(op => (
                        <li key={op.id} className="text-base">
                          {op.producto} (ID: {op.id}) - Estado: <span className={`font-medium ${op.estado === 'iniciada' ? 'text-indigo-600' : 'text-red-600'}`}>{op.estado.charAt(0).toUpperCase() + op.estado.slice(1)}</span>
                          {op.inicio && ` - Inicio: ${formatDateTime(op.inicio)}`}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

                {completedOps.length > 0 && (
                  <div>
                    <h4 className="text-lg font-semibold text-emerald-700 mb-2">Operaciones Terminadas:</h4>
                    <ul className="list-disc list-inside space-y-1 text-gray-700">
                      {completedOps.map(op => (
                        <li key={op.id} className="text-base">
                          {op.producto} (ID: {op.id}) - Unidades: <span className="font-medium text-emerald-600">{op.unidades}</span>
                          {op.fin && ` - Fin: ${formatDateTime(op.fin)}`}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

                {operarioOperations.length === 0 && (
                  <p className="text-gray-500 text-base">Este operario aún no tiene operaciones asignadas o terminadas.</p>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default OperarioHistory;